import { createReducer, on } from "@ngrx/store";
import { ProposalReceipt, ProposalReceiptSummary } from "app/entities";
import { Error, Status } from "../AppState";
import { logoutUserSuccess } from "../user/user.actions";
import {
    clearProposalReceipts,
    createProposalReceipt,
    createProposalReceiptFailure,
    createProposalReceiptSuccess,
    deleteProposalReceipt,
    deleteProposalReceiptFailure,
    deleteProposalReceiptSuccess,
    loadProposalReceipts,
    loadProposalReceiptsFailure,
    loadProposalReceiptsSuccess,
    updateProposalReceipt,
    updateProposalReceiptFailure,
    updateProposalReceiptSuccess,
} from "./proposal-receipt.actions";

export interface ProposalReceiptState {
    proposalId: number | null;
    receipts: ProposalReceipt[];
    summary: ProposalReceiptSummary | null;
    error: Error | null;
    status: Status | null;
}

export const initialState: ProposalReceiptState = {
    proposalId: null,
    receipts: [],
    summary: null,
    error: null,
    status: {
        statusName: 'pending',
        isError: false,
        isFinished: false
    },
};

const loadingStatus = {
    statusName: 'loading',
    isError: false,
    isFinished: false
};

const successStatus = {
    statusName: 'success',
    isError: false,
    isFinished: true
};

export const proposalReceiptReducer = createReducer(
    initialState,
    on(loadProposalReceipts, (state, { proposalId }) => ({
        ...state,
        proposalId,
        receipts: state.proposalId === proposalId ? state.receipts : [],
        summary: state.proposalId === proposalId ? state.summary : null,
        status: loadingStatus,
        error: null,
    })),
    on(createProposalReceipt, updateProposalReceipt, deleteProposalReceipt, (state) => ({
        ...state,
        status: loadingStatus,
    })),
    on(clearProposalReceipts, () => initialState),
    on(loadProposalReceiptsSuccess, (state, { proposalId, receipts, summary }) => ({
        ...state,
        proposalId,
        receipts,
        summary,
        status: successStatus,
        error: null,
    })),
    on(createProposalReceiptSuccess, updateProposalReceiptSuccess, (state, { receipt }) => ({
        ...state,
        receipts: [
            ...state.receipts.filter(current => current.id !== receipt.id),
            receipt,
        ].sort((a, b) => (a.receiptNumber || 0) - (b.receiptNumber || 0)),
        status: successStatus,
        error: null,
    })),
    on(deleteProposalReceiptSuccess, (state, { receiptId }) => ({
        ...state,
        receipts: state.receipts.filter(receipt => receipt.id !== receiptId),
        status: successStatus,
        error: null,
    })),
    on(loadProposalReceiptsFailure, createProposalReceiptFailure, updateProposalReceiptFailure, deleteProposalReceiptFailure, (state, { error }) => ({
        ...state,
        error,
        status: {
            statusName: 'error',
            isError: true,
            isFinished: true
        },
    })),
    on(logoutUserSuccess, () => initialState),
);
